import { render, staticRenderFns } from "./PressDiePressingCountTab.vue?vue&type=template&id=08aef16b&"
import script from "./PressDiePressingCountTab.vue?vue&type=script&lang=js&"
export * from "./PressDiePressingCountTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports